import type { ComponentProps } from "react";

import { MoreDetailsButton, ServiceCardTemplate } from "./card-template";
import { SERVICE_IMAGE_BLOCK_CLASS_NAME } from "./common";

import { cn } from "~/shared/ui";
import type { Card } from "~/shared/ui/card";
import { Skeleton } from "~/shared/ui/skeleton";

type Props = ComponentProps<typeof Card>;

function ServiceCardSkeleton({ ...props }: Props) {
  return (
    <ServiceCardTemplate
      service={{
        name: <Skeleton className="h-5" />,
        description: <Skeleton className="h-6" />,
        image: <Skeleton className={cn(SERVICE_IMAGE_BLOCK_CLASS_NAME, "h-48 rounded-t-xl")} />,
      }}
      button={<MoreDetailsButton disabled />}
      {...props}
    />
  );
}

export { ServiceCardSkeleton };
